module.exports = __webpack_public_path__ + "static/media/1.68bcc995.png";